import _ from "lodash";
import { call, dispatch, get, sync } from "vuex-pathify";

export default {
    computed: {
        userChoiceNeeded: sync("configure/userChoiceNeeded"),
        originatingOptionAnAddition: get(
            "configure/configuration@originatingOptionAnAddition"
        ),

        isAddition() {
            return this.originatingOptionAnAddition === true;
        }
    },
    methods: {
        undo: call("configure/undo"),
        getName(option) {
            const primaryName = _.get(
                _.find(_.get(option, "descriptions"), { type: "PRIMARY_NAME" }),
                "description"
            );
            const consumerFriendly = _.filter(_.get(option, "descriptions"), {
                type: "CONSUMER_FRIENDLY"
            });

            if (_.size(consumerFriendly) > 0) {
                return consumerFriendly[0].description;
            }

            return primaryName;
        },
        hasDescription(option) {
            const extended = _.get(
                _.find(_.get(option, "descriptions"), { type: "EXTENDED" }),
                "description"
            );
            const consumerFriendly = _.filter(_.get(option, "descriptions"), {
                type: "CONSUMER_FRIENDLY"
            });

            return _.size(consumerFriendly) > 1 || !_.isNil(extended);
        },
        getDescription(option) {
            const extended = _.get(
                _.find(_.get(option, "descriptions"), { type: "EXTENDED" }),
                "description"
            );
            const consumerFriendly = _.filter(_.get(option, "descriptions"), {
                type: "CONSUMER_FRIENDLY"
            });

            if (_.size(consumerFriendly) > 1) {
                return consumerFriendly[1].description;
            }

            return extended;
        },
        getCost(option) {
            const selectionState = _.get(option, "selectionState");
            const msrp = _.get(option, "msrp");

            if (selectionState === "INCLUDED" || _.isNil(msrp)) {
                return "Inc.";
            }

            return msrp;
        },

        onSelect(option) {
            this.userChoiceNeeded = false;
            dispatch("configure/selectOption", option.chromeOptionCode);
        }
    }
};
